// extracted by mini-css-extract-plugin
export default {"formContainer":"form_formContainer__RJkuc","marginTop8":"form_marginTop8__mzvmp","marginTop4":"form_marginTop4__twdpK","toggleContainer":"form_toggleContainer__4+Em8"};